import SendGuideForm from './SendGuideForm';

export default SendGuideForm;
